<template>
	<div style="text-align: center">
		<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-sizes="[15, 30, 50, 100]"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		>
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: "PageComp",
	props: {
		total: {
			type: Number,
			default: 0,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		pageSize: {
			type: Number,
			default: 15,
		},
	},
	setup(props, { emit }) {
		const handleSizeChange = (val) => {
			emit("handleSizeChange", val);
		};
		const handleCurrentChange = (val) => {
			emit("handleCurrentChange", val);
		};
		return {
			handleSizeChange,
			handleCurrentChange,
		};
	},
};
</script>

<style scoped>
</style>
